<script setup lang="ts">
import { useVModel } from "@vueuse/core"

type Props = {
    visible: boolean
}

const emit = defineEmits(["update:visible"])

const props = defineProps<Props>()

const modelVisible = useVModel(props, "visible", emit, {
    eventName: "update:visible",
})
</script>
<template>
    <BaseDialog
        v-model:visible="modelVisible"
        modal
        header="Edit Profile"
        :style="{ width: '39rem' }"
        class="dialog-pce"
        :pt="{
            content: 'dialog-pce-content',
            header: 'dialog-pce-header',
        }"
    >
        <template #header>
            <div class="flex flex-col gap-2 mx-auto items-center py-4">
                <img
                    src="https://res.cloudinary.com/dcoutwkb1/image/upload/w_120,q_auto,f_auto/v1746454894/4ee22d4cc24d61ab00885c63006a113b89a54e11_zk5gqb.png"
                    alt="Icône d'information"
                    loading="lazy"
                    class="w-8 h-8"
                />
                <h4 class="font-bold text-primary-400 text-center">
                    Où trouver mon numéro de compteur ?
                </h4>
            </div>
        </template>
        <!-- Sur Facture-->
        <div class="flex gap-6 items-center pb-6 flex-col md:flex-row">
            <p>
                Le PCE (Point de Comptage et d'Estimation) est
                <strong>indiqué à gauche</strong>, dans la section dédiée aux
                informations de votre contrat
                <strong>sur votre facture</strong>.
            </p>
            <img
                src="https://res.cloudinary.com/dcoutwkb1/image/upload/v1747842923/facture_bupgya.svg"
                alt="Facture"
            />
        </div>
        <div class="flex align-center justify-center py-2">
            <BaseButton
                label="Quitter"
                class="!min-w-fit"
                @click="modelVisible = false"
            />
        </div>
    </BaseDialog>
</template>

<style>
.dialog-pce-header {
    --p-dialog-header-padding: 24px 36px;
}
.dialog-pce-content {
    --p-dialog-content-padding: 0 36px 24px 36px;
}
</style>
